import React from 'react';
import bem from 'utils/bem';
import Text from 'components/Text';
import './index.sass';
import { useMobile } from 'utils/media';

const { block, el } = bem('office-map');
const OfficeMap = () => {
  const { isMobile } = useMobile();
  return (
    <div className={ block() }>
      { isMobile && <div className={ el('title') }><Text serif>Схема проезда</Text></div> }
      <div className={ el('image') } />
      <div className={ el('info') }>
        <div className={ el('address') }><Text serif>4-ая Тверская-Ямская ул., 22</Text></div>
        <div className={ el('description') }>
          <Text>
            Вход в пространство и магазин «Ответ» находится во дворе дома. Вход через калитку.
          Нажмите 99 или 98. Идите направо по указателям Ответ. Подъезд с вывеской Ответ.
          </Text>
        </div>
      </div>
    </div>
  )
}

export default OfficeMap;
